import { useMemo } from 'react';
import useAsync from 'react-use/esm/useAsync';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import type { Entity } from '@backstage/catalog-model';
import { isEntityTabConfigOwner } from './isEntityTabConfigOwner';

/**
 * True when the signed-in user may manage entity tab visibility via
 * `ownedBy` or `githubRepoAdminBy` relations.
 */
export function useIsEntityTabConfigOwner(
  entity: Entity | undefined,
): boolean {
  const identityApi = useApi(identityApiRef);
  const { value: identity } = useAsync(
    () => identityApi.getBackstageIdentity(),
    [identityApi],
  );

  return useMemo(() => {
    if (!entity) {
      return false;
    }
    return isEntityTabConfigOwner(
      entity,
      identity?.ownershipEntityRefs ?? [],
    );
  }, [entity, identity?.ownershipEntityRefs]);
}
